<template>
  <div class="match-item">
    <div class="item-right flex-middle" v-if="data.myGuessOrderNum == 1">我已投注</div>
    <div class="item-right flex-middle" v-if="data.myGuessOrderNum > 1">已追单{{ data.myGuessOrderNum - 1 }}次</div>
    <div class="item-title flex-row align-center">
      <div class="t">{{ data.title }}</div>
      <div class="s">总奖池：{{ data.amount_list[0] + data.amount_list[1] }}鹰钻</div>
    </div>
    <div class="item-content flex-row">
      <div class="flex-row vs-team">
        <div class="left flex-column">
          <div :style="{ background: data.status == 1 ? '#eef8ff' : '#F4F4F4' }" class="item-body flex-row flex-middle" @click="toBet(1)">
            <div class="logo">
              <img v-if="data.status == 1" :src="require('@/assets/img/guessing-management/match-logo-3.png')" />
              <img v-else src="@/assets/img/guessing-management/game-over.png" />
            </div>
            <div class="item-progress">
              <el-progress :text-inside="true" :stroke-width="6" :percentage="data.status == 1 ? data.progress_list[0] : 0"></el-progress>
            </div>
            <div :style="{ color: data.status == 1 ? '#3c9cfe' : '#666666' }" class="t">{{ data.contentArr[0] }}</div>
            <div class="s">倍数：{{ data.odds_list[0] }}</div>
          </div>
          <div class="item-desc">{{ data.people_num_list[0] }}人/{{ data.amount_list[0] }}鹰钻</div>
        </div>
        <div class="vs"><img :src="require('@/assets/img/guessing-management/match-vs-2.png')" /></div>
        <div class="right flex-column">
          <div :style="{ background: data.status == 1 ? '#eef8ff' : '#F4F4F4' }" class="item-body flex-row flex-middle" @click="toBet(2)">
            <div class="logo">
              <img v-if="data.status == 1" :src="require('@/assets/img/guessing-management/match-logo-4.png')" />
              <img v-else src="@/assets/img/guessing-management/game-over.png" />
            </div>
            <div class="item-progress">
              <el-progress :text-inside="true" :stroke-width="6" :percentage="data.status == 1 ? data.progress_list[1] : 0"></el-progress>
            </div>
            <div :style="{ color: data.status == 1 ? '#02a8a2' : '#666666' }" class="t">{{ data.contentArr[1] }}</div>
            <div class="s">倍数：{{ data.odds_list[1] }}</div>
          </div>
          <div class="item-desc">{{ data.people_num_list[1] }}人/{{ data.amount_list[1] }}鹰钻</div>
        </div>
      </div>
      <div class="flex-column flex-1 flex-middle vs-status">
        <template v-if="data.status == 1">
          <template v-if="data.endTime > new Date()">
            <div class="t" style="color: #02a8a2">进行中</div>
            <CountDown beforeTimeContent="剩余" :endTime="data.endTime"></CountDown>
          </template>
          <span class="t" v-else style="color: #999999">已结束</span>
        </template>
        <!-- <div v-if="data.status == 4">
          <div class="t" style="color: #02a8a2"></div>
          <div class="t" style="color: #999999">已结束</div>
        </div> -->
        <span class="t" v-if="data.status == 2" style="color: #999999">已封盘</span>
        <span class="t" v-if="data.status == 3" style="color: #999999">已取消</span>
        <span class="t" v-if="data.status == 4" style="color: #999999">已开奖</span>
        <span class="t" v-if="data.status == 5" style="color: #999999">开奖后取消</span>
        <span class="t" v-if="data.status == 6" style="color: #999999">已取消</span>
      </div>
    </div>
  </div>
</template>

<script>
import CountDown from "@/components/count-down/CountDown";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    CountDown,
  },
  mounted() {
    console.log(this.data, "data");
  },
  methods: {
    toBet(result = 0) {
      // this.selectIndex = result;
      if (this.data.status === 1) {
        this.$emit("toBet", { ...this.data, result });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.match-item {
  position: relative;
  background: #ffffff;
  margin: 0.1rem 0rem;
  padding: 0.1rem 0.2rem;
  .item-right {
    position: absolute;
    top: 0.3rem;
    right: 0rem;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    border-radius: 0.3rem 0px 0px 0.3rem;
    padding: 0.1rem 0.15rem;
    font-size: 0.14rem;
    color: #ffffff;
  }

  .item-title {
    padding: 0.05rem 0rem;
    .t {
      color: #02a8a2;
      font-size: 0.16rem;
    }
    .s {
      padding: 0rem 0.1rem;
      color: #999999;
    }
  }
  .item-content {
    .vs-team {
      margin: 0rem 0.3rem;
      padding: 0.05rem 0rem;

      .item-desc {
        color: #666666;
        font-size: 0.14rem;
        padding: 0.05rem 0rem;
      }
      .item-body {
        height: 0.7rem;
        width: 3rem;
        background: #2c3e4c;
        border-radius: 3px;
        position: relative;
        .logo {
          height: 0.7rem;
          width: 0.7rem;
          position: absolute;
          z-index: 2;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item-progress {
          position: absolute;
          bottom: -2px;
          width: 100%;
          z-index: 1;
          ::v-deep {
            .el-progress-bar__innerText {
              display: none;
            }
          }
        }
        .t {
          font-size: 0.2rem;
        }
        .s {
          font-size: 0.13rem;
          margin-left: 0.1rem;
          color: #666666;
        }
      }
      .left {
        cursor: pointer;

        .item-body {
          background: #eef8ff;
          .logo {
            left: -0.35rem;
          }
          .t {
            color: #3c9cfe;
          }
        }
        .item-desc {
          margin-left: -0.3rem;
        }

        ::v-deep {
          .el-progress-bar__inner {
            background: linear-gradient(90deg, #635fff 0.18%, #68bfff 100.18%);
          }
        }
      }
      .right {
        cursor: pointer;
        .item-body {
          background: #e9fffe;
          .logo {
            right: -0.35rem;
          }
          .item-progress {
            transform: rotateY(180deg);
          }
          .t {
            color: #02a8a2;
          }
        }
        .item-desc {
          text-align: right;
          margin-right: -0.3rem;
        }

        ::v-deep {
          .el-progress-bar__inner {
            background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
          }
        }
      }
      .vs {
        margin: 0rem 0.1rem;
        img {
          height: 0.7rem;
        }
      }
    }

    .vs-status {
      .t {
        font-size: 0.16rem;
        font-weight: 500;
        height: 0.4rem;
        line-height: 0.4rem;
      }
      .s {
        color: #db6372;
        font-size: 0.14rem;
        height: 0.3rem;
        line-height: 0.3rem;
      }
    }
  }
}
</style>
